import React from "react";
import { useAuth } from "../../../contexts/auth";
import { IMenu } from "../../../interfaces/IMenu";
import MenuLayout from "../../components/MenuLayout/MenuLayout";
import "./Home.css";

interface Props {
    pageName: string;
}

const Home = ({ pageName }: Props): JSX.Element => {

    //States
    const { userInformation } = useAuth();

    const rolList = ['Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta', 'Gerente de Venta'];
    return (
        <MenuLayout currentPage={pageName}>
            <div className="home_container">
                <div className="sideLeft">
                    <div className="welcomeCase">
                        <label className="hour">{new Date().toDateString()}</label>
                        <div className="welcome">
                            <div className="name">Hey {userInformation?.primerNombre} {userInformation?.primerApellido}!  {process.env.REACT_APP_API_URL}</div>
                            <div className="caption">Bienvenido de vuelta</div>
                        </div>
                        <div className="welcomeIlust"> </div>
                    </div>
                    <div className="homeIlustration"></div>
                </div>

                <div className="rolCase">
                    <div className="title">
                        Roles
                    </div>
                    <div className="rolList">
                        <ul>
                            {!!userInformation && userInformation?.usuarioProyecto!.usuarioProyectoRol.length > 0
                                ? userInformation?.usuarioProyecto!.usuarioProyectoRol.map(rol => (
                                    <li key={rol.rolNombre + rol.rolID} className="rol">{!!rol.rolNombre ? rol.rolNombre : "Sin nombre"}</li>
                                ))
                                : <p className="rol">Sin roles</p>

                            }
                        </ul>
                    </div>
                    <div className="rolIlust"> </div>
                </div>
            </div>
        </MenuLayout>
    );
}



export default Home;